module.exports = __webpack_public_path__ + "img/smockup-bnw.877948ba.jpg";